import React, {useContext} from 'react';
import styles from './ReferralLandingPage.module.css';
import star_icon from '../../static_files/point icon.svg';
import logo_svg from "../../static_files/Prismax Logo.svg";
import goldBg from "../../static_files/buttonBackgroundGold.svg";
import {useParams} from 'react-router-dom';
import {APP_URL} from '../../configs/config';
import {SwapMainAppContext} from "../../context/SwapMainAppContext";


function ReferralLandingPage() {
    const {referralCode} = useParams();
    const {showNotification} = useContext(SwapMainAppContext);


    const goHome = () => {
        if (referralCode) {
            const url = `${APP_URL}?ref=${referralCode}`;
            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            showNotification("error", "A network error has occurred. Please refresh the page and try again.")
        }
    };


    return (
        <div className={styles.pageContainer}>

            <div className={styles.mainContainer}>

                <div className={styles.greenBox}>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}><img src={logo_svg}
                                                                                                 alt='PrismaX'/></div>

                    <p className={styles.subtitle}>
                        A friend invited you to join the robotic revolution! Become an <br/>Explorer member today and
                        start earning Prisma Points together. </p>


                    <div className={styles.infoBlock}>
                        <img className={styles.star_icon} src={star_icon}
                             alt="Star"></img>
                        <div className={styles.starContainer}>
                            <span className={styles.infoTitle}><span style={{fontWeight: '700px'}}>Instant welcome bonus:</span> 1,000 Prisma Points upon joining</span>

                        </div>

                    </div>

                    <div className={styles.infoBlock}>
                        <img className={styles.star_icon} src={star_icon}
                             alt="Star"></img>
                        <div className={styles.starContainer}>
                            <h2 className={styles.infoTitle}><span>Learning rewards:</span> Earn 3,500 more points by
                                reading our
                                whitepaper and acing the quiz </h2></div>


                    </div>
                    <div style={{display: "flex", justifyContent: 'center', width: '100%'}}>

                        <button
                            className={styles.upgradeButton}
                            onClick={goHome}
                            style={{backgroundImage: `url(${goldBg})`}}
                        >
                            Join Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReferralLandingPage;